export const REDUCERS_NAME = {
  ROUTER: 'router'
}
